// extracted by mini-css-extract-plugin
export default {"compareBox":"ReviewChanges_compareBox__0hdui","currentValueBox":"ReviewChanges_currentValueBox__QsvsG","previousValueBox":"ReviewChanges_previousValueBox__IeLPO"};